<template lang="pug">
  #narrative
    v-container(fluid)
      v-form
        v-row
          label.custom Circunstancias relevantes previas a la desaparición
          v-tooltip(
            right  
            color="grey darken-3"
            open-on-click
            :open-on-hover="hoverTooltip" )
            template(v-slot:activator="{ on }")
              v-icon(v-on="on" small) mdi-information
            span.tooltip
              span ¿Antecedentes de algún conflicto previo?
              br
              span ¿Dónde trabaja y desde cuándo?
              br
              span ¿En la zona se había presentado algún hecho fuera de lo común y que sea relevante?	


        v-row
          v-textarea.pt-0(
            v-model="relevantCircunstances"
            label=""
            multi-line
          )

        v-row
          label.custom Hechos de la desaparición: circunstancias de tiempo, modo y lugar
          v-tooltip(
            right  
            color="grey darken-3"
            open-on-click
            :open-on-hover="hoverTooltip"
            tabindex=0
            )
            template(v-slot:activator="{ on }")
              v-icon(v-on="on" small) mdi-information
            span.tooltip
              span ¿Qué sucedió y cómo se enteró la persona entrevistada?
              br
              span ¿Cuándo fue la última vez que se tuvo contacto con la persona desaparecida?
              br
              span ¿Cuáles son los datos de la persona que le dio aviso de la desaparición?
              br
              span ¿En qué circunstancias se enteró?
              br
              span ¿Cuál es la hora aproximada de la desaparición?
              br
              span ¿Desde qué hora aproximada el celular de la persona desaparecida se encontraba apagado o no contestaba?
              br
              span ¿Desaparecieron más personas en el mismo hecho o en hechos cercanos?
        v-row      
          v-textarea(
            v-model="disappearanceFacts"
            label=""
            multi-line
          )
        
        v-row
          Details

        v-row
          Perpetrators

        v-row
          Actions

        v-divider.form.my-4
        v-row
          Location

</template>

<script>
import Details from "./Narrative/Details.vue";
import Perpetrators from "./Narrative/Perpetrators.vue";
import Actions from "./Narrative/Actions.vue";
import Location from "./Narrative/Location.vue";

export default {
  name: "Narrative",
  components: {
    Details,
    Perpetrators,
    Actions,
    Location
  },
  data(){
    return {
      hoverTooltip: false
    }
  },
  computed: {
    relevantCircunstances: {
    	get() {
    		return this.$store.state.record.narrative.relevantCircunstances;
    	},
    	set(value) {
    		this.$store.state.record.narrative.relevantCircunstances = value;
    	}
    },
    disappearanceFacts: {
      get() {
    		return this.$store.state.record.narrative.disappearanceFacts;
    	},
    	set(value) {
    		this.$store.state.record.narrative.disappearanceFacts = value;
    	}
    }
  }
};
</script>

<style scoped lang="scss">
.col {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}
.tooltip {
  span { 
    color: white;
    font-size: 11.5px;
  }
 
}
</style>
